import React, { useState } from "react";
import "./ContactUs.css";

export default function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    // Clear error when user types again
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Full Name is required";
    } else if (formData.name.length < 3) {
      newErrors.name = "Name must be at least 3 characters";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Please enter a valid email";
    }

    if (!formData.subject.trim()) {
      newErrors.subject = "Subject is required";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    } else if (formData.message.length < 10) {
      newErrors.message = "Message must be at least 10 characters long";
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length === 0) {
      console.log("Form submitted successfully:", formData);
      setSubmitted(true);
      setFormData({
        name: "",
        email: "",
        subject: "",
        message: "",
      });
      setErrors({});
    } else {
      setErrors(validationErrors);
      setSubmitted(false);
    }
  };

  return (
    <div className="contactUs-page-wrapper">
      <header className="contactUs-header">
        <h1 className="contactUs-heading">Get in Touch</h1>
        <p className="contactUs-subheading">
          Have questions or want to collaborate? We’d love to hear from you.
        </p>
      </header>

      <section className="contactUs-body">
        <div className="contactUs-infoCard">
          <h2 className="contactUs-infoTitle">Chief Editor</h2>
          <p className="contactUs-infoName">Mr. S. Ratheesh</p>
          <div className="contactUs-divider"></div>

          <div className="contactUs-detailItem">
            <span className="contactUs-label">Mobile</span>
            <span className="contactUs-value">+91-9095059984</span>
          </div>
          <div className="contactUs-detailItem">
            <span className="contactUs-label">Email</span>
            <span className="contactUs-value">sratheeshtpm@gmail.com</span>
          </div>
        </div>

        <form className="contactUs-formCard" onSubmit={handleSubmit}>
          <div className="contactUs-formGroup">
            <label className="contactUs-formLabel">Full Name</label>
            <input
              type="text"
              name="name"
              placeholder="Enter your full name"
              value={formData.name}
              onChange={handleChange}
              className={`contactUs-input ${errors.name ? "error" : ""}`}
            />
            {errors.name && (
              <span className="contactUs-error">{errors.name}</span>
            )}
          </div>

          <div className="contactUs-formGroup">
            <label className="contactUs-formLabel">Email Address</label>
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              className={`contactUs-input ${errors.email ? "error" : ""}`}
            />
            {errors.email && (
              <span className="contactUs-error">{errors.email}</span>
            )}
          </div>

          <div className="contactUs-formGroup">
            <label className="contactUs-formLabel">Subject</label>
            <input
              type="text"
              name="subject"
              placeholder="Enter the subject"
              value={formData.subject}
              onChange={handleChange}
              className={`contactUs-input ${errors.subject ? "error" : ""}`}
            />
            {errors.subject && (
              <span className="contactUs-error">{errors.subject}</span>
            )}
          </div>

          <div className="contactUs-formGroup">
            <label className="contactUs-formLabel">Message</label>
            <textarea
              name="message"
              placeholder="Write your message here..."
              value={formData.message}
              onChange={handleChange}
              className={`contactUs-textarea ${errors.message ? "error" : ""}`}
              rows="5"
            />
            {errors.message && (
              <span className="contactUs-error">{errors.message}</span>
            )}
          </div>

          <button type="submit" className="contactUs-submitButton">
            Send Message
          </button>

          {submitted && (
            <p className="contactUs-successMsg">
              ✅ Thank you! Your message has been sent successfully.
            </p>
          )}
        </form>
      </section>
    </div>
  );
}
